import { ClientStorage } from './storage';

const STATE_STORAGE_KEY = 'da-auth.js.state';

interface StateObject {
  nonce: string;
  scope?: string;
  audience?: string;
  appState?: any;
}

export class StateManager {
  private stateObject: StateObject;

  constructor(private storage: ClientStorage) {
    this.stateObject = this.storage.get(STATE_STORAGE_KEY);
  }

  public create(transaction: StateObject) {
    this.stateObject = transaction;

    this.storage.save(STATE_STORAGE_KEY, transaction, {
      daysUntilExpire: 1
    });
  }

  public get(): StateObject {
    return this.stateObject;
  }

  public remove() {
    // @ts-ignore
    delete this.stateObject;
    this.storage.remove(STATE_STORAGE_KEY);
  }
}
